"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALLOWED_IMAGE_FORMATS = void 0;
var ALLOWED_IMAGE_FORMATS = ['image/jpeg', 'image/png'];
exports.ALLOWED_IMAGE_FORMATS = ALLOWED_IMAGE_FORMATS;